// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2061":"160c93df","4391":"b12176ee","4763":"c2f88cf2","4960":"68c23358","7542":"a1c0b266","8430":"39743a37","8475":"194feefa","8875":"a1c0b266","9930":"39743a37"}[chunkId] + ".chunk.css";
};